import { I18nLocale, isI18nLocale } from '#/i18n/types/I18nLocale';

export type LoaderDataWithOverrideLocale = {
  overrideLocale: I18nLocale | null;
} & Record<string, unknown>;

type Args = {
  matches: unknown[];
};

export function getMatchesOverrideLocale({ matches }: Args): {
  overrideLocale: I18nLocale | null;
} {
  for (let i = matches.length - 1; i > 0; i--) {
    const match = matches[i];

    if (
      match &&
      typeof match === 'object' &&
      'loaderData' in match &&
      match.loaderData &&
      typeof match.loaderData === 'object' &&
      'overrideLocale' in match.loaderData &&
      typeof match.loaderData.overrideLocale === 'string' &&
      isI18nLocale(match.loaderData.overrideLocale)
    ) {
      return { overrideLocale: match.loaderData.overrideLocale };
    }
  }

  return { overrideLocale: null };
}
